<template>
  <div
    class="ts-bg-gray-200 ts-border-blue-500 ts-rounded-b-md ts-p-3 ts-space-y-3"
  >
    <div>
      <label>{{ $t('saleContract.broker') }}</label>
      <div class="ts-flex ts-items-center">
        <a-select
          show-search
          v-model="model.broker_id"
          style="width: 100%"
          :default-active-first-option="false"
          :show-arrow="false"
          :filter-option="false"
          clearable
          :not-found-content="null"
          :placeholder="$t('saleContract.typeToSearch')"
          :loading="fetching_broker"
          @search="onBrokerSearch"
          @on-clear="onBrokerClear"
          :options="brokerList"
        >
        </a-select>
        <a
          href="#"
          @click.prevent="() => (add_new_broker = true)"
          v-tooltip="$t('add_new')"
          class="ts-bg-blue-500 ts-h-8 ts-w-8 ts-text-white ts-flex ts-items-center ts-rounded-tr ts-rounded-br hover:ts-text-white"
          ><i class="fas fa-plus-square ts-mx-auto"></i
        ></a>
      </div>
      <div class="validate" v-if="errors.has('broker_id')">
        {{ errors.first('broker_id') }}
      </div>
    </div>
    <div>
      <label>{{ $t('saleContract.brokerAmount') }}</label>
      <input
        :disabled="!isBroker"
        v-model.number="model.broker_amount"
        type="number"
        class="form-control"
      />
      <div class="validate" v-if="errors.has('broker_amount')">
        {{ errors.first('broker_amount') }}
      </div>
    </div>
    <!-- add customer -->
    <a-drawer
      v-if="add_new_broker"
      :title="$t('saleContract.createNewBroker')"
      :width="400"
      :zIndex="1020"
      :visible="add_new_broker"
      :body-style="{ paddingBottom: '80px' }"
      :maskClosable="false"
      @close="() => (add_new_broker = false)"
    >
      <AddNewBroker @cancel="onCancel" @data="setBroker" :cus_type="3" />
    </a-drawer>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'
import { debounce } from 'lodash'
import moment from 'moment'
import AddNewBroker from './add-new-broker.vue'

export default {
  name: 'broker',
  props: ['value', 'validate'],
  components: {
    AddNewBroker
  },
  data () {
    return {
      errors: new Errors(),
      add_new_broker: false,
      fetching_broker: false,
      model: {}
    }
  },
  mounted () {
    this.model = this.value
  },
  computed: {
    ...mapState('wholesale/saleContract', ['formViewData']),
    brokerList () {
      if (!this.formViewData.broker) return []
      return this.formViewData.broker.map(el => ({
        value: el.customer_id,
        label: el.ss_id_card
          ? el.ss_id_card +
            '|' +
            el.customer_name +
            (el.contact_number ? '|' + el.contact_number : '')
          : el.customer_name +
            (el.contact_number ? '|' + el.contact_number : ''),
        credit_amount: el.credit_amount,
        credit_day: el.credit_day
      }))
    },
    isBroker () {
      if (this.model.broker_id) return true
      return false
    }
  },
  methods: {
    ...mapActions('wholesale/saleContract', ['getFormViewData']),
    onBrokerSearch: debounce(function (value) {
      this.fetching_broker = true
      this.getFormViewData({
        index: 'broker',
        params: {
          fnName: 'broker',
          broker_search: value
        }
      }).finally(() => (this.fetching_broker = false))
    }, 500),
    onCancel () {
      this.add_new_broker = false
    },
    onBrokerClear () {
      this.model.broker_amount = null
    },
    setBroker (data) {
      this.$store.commit('wholesale/saleContract/PUSH_NEW_BROKER', data)
      this.model.broker_id = data.customer_id
    }
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
